import "./App.css";
import Layout from "./Layout/Layout";

function App() {
  return (
    <>
      <Layout />

      {/* =================
         Animate.css CDN
      ===================== */}
      <link
        rel="stylesheet"
        href="https://cdnjs.cloudflare.com/ajax/libs/animate.css/4.1.1/animate.min.css"
      />
    </>
  );
}

export default App;
